/**
 * OnhowDescriptionAccordion (+ / – icon)
 * Lightweight + fast for Shopify Dawn
 * Builds an accordion from H3 sections inside .product__description.rte
 */

(() => {
  // Prevent double-initialization
  if (window.__RUHRA_ACCORDION_INIT__) return;
  window.__RUHRA_ACCORDION_INIT__ = true;

  const onhowStyles = `
    /* Row layout */
    .onhow-accordion summary{
      cursor:pointer;
      display:flex;
      justify-content:space-between;
      align-items:center;
      list-style:none; /* remove default marker */
    }
    .onhow-accordion summary::-webkit-details-marker{ display:none; }

    /* Title size (keeps your original scaling) */
    .onhow-accordion .accordion__title{
      font-size:calc(var(--font-heading-scale) * 1.13em);
      margin:0;
    }
      /* Separator lines */
.onhow-accordion details {
  border-bottom: 1px solid #e5e5e5; /* light gray underline */
}

.onhow-accordion details:first-child {
  border-top: 1px solid #e5e5e5; /* top border for first row */
}

/* Padding inside rows */
.onhow-accordion summary {
  padding: 14px 0; /* vertical spacing for better touch target */
}

/* Open animation + spacing */
.onhow-accordion details[open] .accordion__content {
  animation: slowReveal 250ms ease-in-out;
  padding: 10px 0 14px 0;
}

@keyframes slowReveal {
  0% { opacity: 0; transform: translateY(-6px); }
  100% { opacity: 1; transform: translateY(0); }
}


    /* + icon */
    .onhow-accordion .accordion-icon .icon-plus{
      width:16px;
      height:16px;
      transition:transform .25s ease;
      display:inline-block;
      flex:0 0 16px;
      margin-left:12px;
    }

    /* When open: hide vertical line to show a minus */
    .onhow-accordion details[open] .icon-plus line:first-child{ display:none; }

    /* Open animation */
    .onhow-accordion details[open] .accordion__content{
      animation:slowReveal 250ms ease-in-out;
    }
    @keyframes slowReveal{
      0%{opacity:0; transform:translateY(-6px);}
      100%{opacity:1; transform:translateY(0);}
    }
  `;

  function addStyles(css){
    if (document.getElementById('onhow-accordion-styles')) return;
    const el = document.createElement('style');
    el.id = 'onhow-accordion-styles';
    el.textContent = css;
    document.head.appendChild(el);
  }

  class OnhowDescriptionAccordion {
    constructor(container){
      this.descriptionContainer = container;
      this.originalContent = this.descriptionContainer.innerHTML;
      addStyles(onhowStyles);
      const h3s = this.descriptionContainer.querySelectorAll('h4');
      if (!h3s.length) return; // Nothing to do if no sections
      this.createAccordion(h3s);
    }

    createAccordion(h3Elements){
      const accordion = document.createElement('div');
      accordion.className = 'onhow-accordion product__accordion accordion quick-add-hidden';

      h3Elements.forEach((h3, index) => {
        // Collect content until next H3
        const contentFrag = document.createDocumentFragment();
        let el = h3.nextElementSibling;
        while (el && el.tagName !== 'H4'){
          contentFrag.appendChild(el.cloneNode(true));
          el = el.nextElementSibling;
        }

        const details = document.createElement('details');
        details.id = `Details-onhow-${index}`;
        if (index === 0) details.setAttribute('open', '');

        const summary = document.createElement('summary');
        summary.setAttribute('role','button');
        summary.setAttribute('aria-controls', `ProductAccordion-onhow-${index}`);
        summary.setAttribute('aria-expanded', index === 0 ? 'true' : 'false');

        const summaryTitle = document.createElement('div');
        summaryTitle.className = 'summary__title';

        const heading = document.createElement('h4');
        heading.className = 'accordion__title';
        heading.textContent = h3.textContent;

        const icon = document.createElement('span');
        icon.className = 'accordion-icon';
        icon.innerHTML = `
          <svg viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false" class="icon-plus" xmlns="http://www.w3.org/2000/svg">
            <line x1="10" y1="4"  x2="10" y2="16" stroke="currentColor" stroke-width="2"/>
            <line x1="4"  y1="10" x2="16" y2="10" stroke="currentColor" stroke-width="2"/>
          </svg>
        `;

        const content = document.createElement('div');
        content.className = 'accordion__content rte';
        content.id = `ProductAccordion-onhow-${index}`;
        content.appendChild(contentFrag);

        summaryTitle.appendChild(heading);
        summary.appendChild(summaryTitle);
        summary.appendChild(icon);
        details.appendChild(summary);
        details.appendChild(content);
        accordion.appendChild(details);

        // Keep aria-expanded accurate
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        });
      });

      // Replace original description with accordion
      this.descriptionContainer.innerHTML = '';
      this.descriptionContainer.appendChild(accordion);
    }
  }

  function init(){
    const container = document.querySelector('.product__description.rte');
    if (!container || container.dataset.accordionEnhanced === 'true') return;
    new OnhowDescriptionAccordion(container);
    container.dataset.accordionEnhanced = 'true';
  }

  // Defer until DOM ready (your script tag uses defer too)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init, { once:true });
  } else {
    init();
  }

  // If a product section ever re-renders (rare on product page), re-init:
  document.addEventListener('shopify:section:load', init);
})();
